// topRating images
import camera from "../images/camera.webp";
import Shoe from "../images/shoes-2.webp";
import smartPhone from "../images/smart_phone.webp";
import watch from "../images/watch-1.webp";
// topRating images

// featuresBrands images
import london_britches from "../images/london-britches.webp";
import jimandjiko from "../images/jimandjiko.webp";
// featuresBrands images

export const topRatingOne = [
  {
    img: camera,
    text: "Camera",
    price: "$3,300.00",
  },
  {
    img: Shoe,
    text: "Shoe",
    price: "$400.00",
  },
];
export const topRatingTwo = [
  {
    img: smartPhone,
    text: "Phone",
    price: "$999.00",
  },
  {
    img: watch,
    text: "Watch",
    price: "$999.00",
  },
];

export const featuresBrands = [
  { img: london_britches, text: "London Britches" },
  { img: jimandjiko, text: "Jim & Jago" },
];
